export interface EventTemplate {
  id: string;
  label: string;
  description: string;
  format: string;
  scoringBasis: 'gross' | 'net';
  handicapAllowance: number;
  namePrefix: string;
  config?: Record<string, unknown>;
}

export const EVENT_TEMPLATES: EventTemplate[] = [
  {
    id: 'tournament',
    label: 'Tournament',
    description: 'Multi-round club stroke play event',
    format: 'stroke',
    scoringBasis: 'net',
    handicapAllowance: 0.95,
    namePrefix: 'Club Tournament',
  },
  {
    id: 'member-guest',
    label: 'Member-Guest',
    description: 'Member + guest pairs, best ball teams',
    format: 'bestball',
    scoringBasis: 'net',
    handicapAllowance: 0.85,
    namePrefix: 'Member-Guest',
    config: { team_size: 2, pairs: true },
  },
  {
    id: 'club-championship',
    label: 'Club Championship',
    description: 'Gross stroke play championship',
    format: 'stroke',
    scoringBasis: 'gross',
    handicapAllowance: 1,
    namePrefix: 'Club Championship',
    config: { championship: true },
  },
  {
    id: 'league-play',
    label: 'League Play',
    description: 'Season-long league with cumulative standings',
    format: 'stableford',
    scoringBasis: 'net',
    handicapAllowance: 0.95,
    namePrefix: 'League',
    config: { league: true, cumulative: true },
  },
];

export function findEventTemplate(id: string): EventTemplate | undefined {
  return EVENT_TEMPLATES.find((t) => t.id === id);
}
